import { render } from "./ShareJourlyModal.vue?vue&type=template&id=46a54687&scoped=true"
import script from "./ShareJourlyModal.vue?vue&type=script&lang=js"
export * from "./ShareJourlyModal.vue?vue&type=script&lang=js"

import "./ShareJourlyModal.vue?vue&type=style&index=0&id=46a54687&scoped=true&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a54687"]])

export default __exports__